import React from 'react';
import { BillingData, SubscriptionData } from '../BillingTypes';
import { useTranslation } from 'react-i18next';
import { useModal } from 'components/modals/ModalContext';
import AddPaymentDetailsForm from './AddPaymentDetailsForm';

interface AddPaymentDetailsCardProps {
    subscription: SubscriptionData;
    billingData: BillingData;
    refetchBillingDetails: () => void;
    refetchSubscription: () => void;
}

const AddPaymentDetailsCard: React.FC<AddPaymentDetailsCardProps> = ({ 
    subscription, billingData, refetchBillingDetails, refetchSubscription
}) => {
    const { t } = useTranslation();
    const { initializeModal } = useModal();

    // Initialize the revert subscription cancellation modal
    const initializePaymentDetailsModal = () => {
        initializeModal(
            <AddPaymentDetailsForm 
                subscriptionId={subscription.id}
                billingData={billingData} 
            />, { 
                title: t('billing.general.add_payment_details_header'),
                modalSize: 'small', 
                onSuccess: () => {refetchBillingDetails(); refetchSubscription()},
            }
        )
    };

    return (
        <div className='card cancel-subscription'>
            <h6>{t('billing.general.no_payment_details_header')}</h6>
            <p>{t('billing.general.add_payment_details_description')}</p>
            <div className='text-button'
                onClick={() => initializePaymentDetailsModal()}>
                {t('billing.general.add_payment_details_button')}
            </div>
        </div>
    )
};

export default AddPaymentDetailsCard;